
























































































































import { BlBreadcrumbAv, BlPaginationMv, BlShimmerAv } from '@bukalapak/bazaar-dweb'
import { BlButtonAv, BlFlexContainerMv, BlFlexItemAv, BlTextAv } from '@bukalapak/bazaar-mweb'
import IcoChevronLeftMinor from '@bukalapak/bazaar-visual/dist/components/IcoChevronLeftMinor'
import { toLower, upperFirst } from 'lodash'
import Vue, { PropType } from 'vue'
import LandingProductCard from '~/components/organisms/LandingPage/Product/card.vue'
import { BlBreadcrumbItem } from '~/types/component/breadcrumbs-type'
import type { CategoryProduct } from '~/types/component/landing-product'
import { MappedPaginationType } from '~/types/component/mapped-pagination-type'
import stringToSlug from '~/utils/converter/string-to-slug'
export default Vue.extend({
  name: 'CategorySlugContent',
  components: {
    BlFlexContainerMv,
    BlFlexItemAv,
    BlBreadcrumbAv,
    BlTextAv,
    BlPaginationMv,
    BlButtonAv,
    BlShimmerAv,
    IcoChevronLeftMinor,
    LandingProductCard,
  },
  props: {
    level: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    products: {
      type: Array as PropType<CategoryProduct[]>,
      required: true,
    },
    pagination: {
      type: Object as PropType<MappedPaginationType>,
      required: true,
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMobile(): boolean {
      return this.$viewport.match('mobile').valueOf()
    },
    breadcrumbLists(): BlBreadcrumbItem[] {
      return [
        {
          name: 'Beranda',
          url: '/',
        },
        {
          name: upperFirst(toLower(this.$route.params.category.replace(/-/gi, ' '))),
          url: `/c/${this.$route.params.category}`,
        },
        ...(this.$route.params.subcategory
          ? [
              {
                name: upperFirst(toLower(this.$route.params.subcategory.replace(/-/gi, ' '))),
                url: `/c/${this.$route.params.category}/${this.$route.params.subcategory}`,
              },
            ]
          : []),
      ]
    },
    pageText(): string {
      const { currentPage } = this.pagination
      return `Halaman ${currentPage || '-'}`
    },
    navigationText(): string {
      const { currentPage, offset, limit, total } = this.pagination
      return `${offset + 1}-${currentPage * limit > total ? total : currentPage * limit} barang dari ${total} barang`
    },
    allLoaded(): boolean {
      const { limit, offset, total } = this.pagination
      return offset + limit >= total
    },
  },
  methods: {
    goBack() {
      window.history.back()
    },
    pageChange(page: number) {
      this.$emit('pageChange', page)
    },
    generateSlug(category) {
      const lowercasedName = `${category.name ?? ''}`.toLowerCase()
      return category.slug || stringToSlug(lowercasedName)
    },
  },
})
